
const prevBtn = document.querySelectorAll('#shade-previous');
const nextBtn = document.querySelectorAll('#shade-next');
const slide = document.querySelector('.shade-image');
const slidesContainer = document.querySelector(".shade-card-image-container");


for(var nb = 0; nb < nextBtn.length; nb++){
    nextBtn[nb].addEventListener('click', function(n){
      var parent =  this.parentElement.parentElement.parentElement.querySelector('.shade-card-image-container');
      var children = parent.querySelectorAll('.shade-image');
      var size = parent.querySelectorAll('.shade-image').length - 1;
      const slideWidth = slide.clientWidth;
      if((parent.getBoundingClientRect().x) == (parent.querySelectorAll('.shade-image')[size]).getBoundingClientRect().x){
        console.log('last child');
        parent.append(children[0]);
        parent.style.scrollBehavior = 'unset';
        parent.scrollLeft -= slideWidth;
        parent.style.scrollBehavior = 'smooth';
        parent.scrollLeft += slideWidth;
      }else{
        
        parent.scrollLeft += slideWidth;
      }
        
    });
}

for(var pb = 0; pb < prevBtn.length; pb++){
    prevBtn[pb].addEventListener('click', function(p){
      var parent =  this.parentElement.parentElement.parentElement.querySelector('.shade-card-image-container');
      var children = parent.querySelectorAll('.shade-image');
      var size = parent.querySelectorAll('.shade-image').length - 1;
      const slideWidth = slide.clientWidth;
      if((parent.getBoundingClientRect().x) == (parent.querySelectorAll('.shade-image')[0]).getBoundingClientRect().x){
        parent.prepend(children[size]);
        parent.style.scrollBehavior = 'unset';
        parent.scrollLeft += slideWidth;
        parent.style.scrollBehavior = 'smooth';
        parent.scrollLeft -= slideWidth;
      }else{
        
        parent.scrollLeft -= slideWidth;
      }
});
}

var allSlidesContainer = document.querySelectorAll('.shade-card-image-container')
window.addEventListener('resize', function(){
   for(var i = 0; i < allSlidesContainer.length; i++) {
       allSlidesContainer[i].scrollLeft -= slidesContainer.clientWidth * 4;
   }
});

